import { Button, ButtonGroup } from '@dixa/lib-shared-habla';
import type {
  InstrumentDataGranularity,
  InstrumentDataGranularityData,
  InstrumentPanel,
} from 'lib-analytics-types';
import { ampli } from 'lib-shared-tracking';
import { memo, useCallback } from 'react';

import { useAnalyticsState } from 'app/views/layout/views/analytics/components/panels/utils/useAnalyticsState/useAnalyticsState';

type ChartInstrumentGranularityProps = {
  /** The containing panel. */
  panel: InstrumentPanel;
  /** The granularities available to select. */
  granularities: readonly InstrumentDataGranularityData[];
  /** The handler to change the granularity. */
  onChangeGranularity?: (granularity: InstrumentDataGranularity) => void;
};

export const ChartInstrumentGranularity = memo(
  function ChartInstrumentVisualization({
    panel,
    granularities,
    onChangeGranularity,
  }: ChartInstrumentGranularityProps): JSX.Element {
    const { dashboard } = useAnalyticsState();

    const handleChange = useCallback(
      (value: InstrumentDataGranularity) => {
        onChangeGranularity?.(value);

        ampli.analyticsChartGranularityChanged({
          granularity: value,
          panel: panel.title,
          dashboard: dashboard.title,
        });
      },
      [dashboard.title, onChangeGranularity, panel.title],
    );

    return (
      <ButtonGroup variant="secondary">
        {granularities.map(({ value, selected }) => (
          <Button
            key={value}
            onClick={selected ? undefined : () => handleChange(value)}
            active={selected}
          >
            {value}
          </Button>
        ))}
      </ButtonGroup>
    );
  },
);
